import { Box, Chip } from "@mui/material";
import { memo } from "react";
import theme from "../theme";
import { useWindowSize } from "@reactuses/core";

type Colors = "green" | "orange" | "red" | "yellow" | "grey";

type Prop = {
  text: string;
  color: Colors;
  withoutMl?: boolean;
  width?: string;
};

export const EventTag = memo(({ text, color, withoutMl, width }: Prop) => {
  const { width: windowWidth } = useWindowSize();
  // 텍스트컬러
  const colorList = {
    green: theme.color.white,
    orange: theme.color.white,
    red: theme.color.white,
    yellow: theme.color.black,
    grey: theme.color.neutral_500,
  };
  const bgColorList = {
    green: theme.color.green_500,
    orange: theme.color.orange_500,
    red: theme.color.red_500,
    yellow: theme.color.yellow_500,

    grey: theme.color.white,
  };

  return (
    <Box
      sx={{
        marginLeft: withoutMl ? "0px" : "5px",
      }}
    >
      <Chip
        label={text}
        sx={{
          width: width,
          backgroundColor: bgColorList[color], // 배경색
          color: colorList[color], // 텍스트 색
          borderColor: colorList[color],
          fontSize: windowWidth <= theme.screen.sm ? "10px" : "13px",
          borderRadius: "4px",
          height: "19px",

          padding: "2px 6px",
          "& .MuiChip-label": {
            padding: "0px",
          },
        }}
        variant={color === "grey" ? "outlined" : "filled"}
        size="small"
      />
    </Box>
  );
});

// export const EventTag = memo(
//   ({ text, color, withoutMl, styleType = "outlined", width }: Prop) => {
//     const { width: windowWidth } = useWindowSize();
//     const colorList = {
//       green: theme.color.green_500,
//       orange: theme.color.orange_500,
//       red: theme.color.red_500,
//       yellow: theme.color.yellow_500,
//       grey: theme.color.neutral_300,
//     };
//     const bgColorList = {
//       green:
//         styleType === "filled"
//           ? theme.color.green_500
//           : theme.color.green_100,
//       orange:
//         styleType === "filled"
//           ? theme.color.orange_500
//           : theme.color.orange_100,
//       red:
//         styleType === "filled" ? theme.color.red_500 : theme.color.red_100,
//       yellow:
//         styleType === "filled"
//           ? theme.color.yellow_500
//           : theme.color.yellow_100,
//       grey:
//         styleType === "filled"
//           ? theme.color.neutral_300
//           : theme.color.white,
//     };

//     return (
//       <Box
//         sx={{
//           marginLeft: withoutMl ? "0px" : "5px",
//         }}
//       >
//         <Chip
//           label={text}
//           sx={{
//             width: width,
//             backgroundColor: bgColorList[color], // 배경색
//             color:
//               styleType === "outlined"
//                 ? colorList[color]
//                 : theme.color.white, // 텍스트 색
//             borderColor: colorList[color],
//             fontSize: windowWidth <= theme.screen.sm ? "10px" : "13px",
//             borderRadius: "4px",
//             height: "19px",

//             padding: "2px 6px",
//             "& .MuiChip-label": {
//               padding: "0px",
//             },
//           }}
//           variant={styleType}
//           size="small"
//         />
//       </Box>
//     );
//   }
// );
